<template>
  <button
    class="financial-privacy-button"
    :class="{ 'financial-privacy-button--hidden': !valuesVisible }"
    type="button"
    :aria-label="valuesVisible ? 'Ocultar valores financeiros' : 'Mostrar valores financeiros'"
    :title="valuesVisible ? 'Ocultar valores financeiros' : 'Mostrar valores financeiros'"
    @click="toggleFinanceValuesVisibility"
  >
    <i :class="valuesVisible ? 'ph ph-eye' : 'ph ph-eye-slash'" aria-hidden="true"></i>
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "FinancialPrivacyButton",
  computed: {
    ...mapGetters({
      valuesVisible: "getFinanceValuesVisible",
      userId: "getId",
    }),
  },
  created() {
    this.initializeFinanceValuesVisibility(this.userId || "default");
  },
  methods: {
    ...mapActions([
      "initializeFinanceValuesVisibility",
      "toggleFinanceValuesVisibility",
    ]),
  },
});
</script>

<style scoped>
.financial-privacy-button {
  align-items: center;
  background: var(--financial-privacy-surface, #fff);
  border: 1px solid var(--financial-privacy-border, #dfe7ed);
  border-radius: 50%;
  color: var(--financial-privacy-ink, #0b355f);
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 42px;
  font-size: 19px;
  height: 42px;
  justify-content: center;
  transition: background-color .2s ease, border-color .2s ease, color .2s ease, transform .2s ease;
  width: 42px;
}

.financial-privacy-button:hover {
  border-color: var(--financial-privacy-accent, #08ad7e);
  color: var(--financial-privacy-accent, #08ad7e);
  transform: translateY(-1px);
}

.financial-privacy-button--hidden {
  background: var(--financial-privacy-hidden-surface, #e8f8f3);
  border-color: var(--financial-privacy-hidden-border, #bde8db);
  color: var(--financial-privacy-accent, #05785d);
}

.financial-privacy-button:focus-visible {
  outline: 3px solid rgba(8, 173, 126, .22);
  outline-offset: 2px;
}
</style>
